import { render, staticRenderFns } from "./RecivePassword.vue?vue&type=template&id=cf78cc56&"
import script from "./RecivePassword.vue?vue&type=script&lang=js&"
export * from "./RecivePassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "RecivePassword.vue"
export default component.exports